export default defineNuxtRouteMiddleware(async (nuxt) => {
  // const isPembelajaranMandiri = /pembelajaran-mandiri/.test(nuxt.path);
  // if (isPembelajaranMandiri) {
  //   await useEcosystemPartnerStore().checkEcosystemAccess();
  //   if (!useEcosystemPartnerStore().hasEcosystemAccess) {
  //     useBelajarWajibStore().clearTokens();
  //     return navigateTo({ path: "/pembelajaran-wajib/login" });
  //   }
  // }
  if (localStorage.getItem("dataPegawai")) {
    useBelajarWajibStore().$patch((state) => {
      state.dataPegawai = JSON.parse(localStorage.getItem("dataPegawai")) || {};
    });
  }
  if (localStorage.getItem("profile")) {
    useBelajarWajibStore().$patch((state) => {
      state.profile = JSON.parse(localStorage.getItem("profile")) || {};
    });
  }
});
